import { Link } from 'react-router-dom';

export function ContactPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-emerald-50 text-slate-900">
      <header className="max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 py-6">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center shadow border border-emerald-200">
            <img
              src="/ats-icon.png"
              alt="ATS CV Checker logo"
              className="w-10 h-10 object-contain"
            />
          </div>
          <span className="text-xl font-semibold text-emerald-900">ATS CV Checker</span>
        </Link>

        <nav className="flex items-center gap-6 text-sm text-slate-700">
          <Link className="hover:text-emerald-700 transition-colors" to="/home">
            Home
          </Link>
          <Link className="hover:text-emerald-700 transition-colors" to="/contact">
            Contact us
          </Link>
        </nav>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">
        <div className="flex items-center justify-between text-sm text-slate-600">
          <div className="flex items-center gap-2">
            <Link className="text-emerald-700 hover:underline" to="/home">
              Home
            </Link>
            <span className="text-slate-400">/</span>
            <span className="font-medium text-slate-700">Contact us</span>
          </div>
        </div>

        <header className="space-y-3">
          <h1 className="text-4xl font-extrabold text-slate-900">Contact us</h1>
          <p className="text-lg text-slate-600">You can contact us with any questions</p>
        </header>

        <section className="bg-emerald-50 border border-emerald-100 rounded-2xl p-6 sm:p-8 shadow-sm">
          <div className="text-base sm:text-lg text-slate-700 flex flex-col gap-2">
            <span className="font-semibold text-slate-800">E-mail:</span>
            <a
              href="mailto:ai.resume.build@gmail.com"
              className="text-emerald-700 font-medium underline underline-offset-4"
            >
              ai.resume.build@gmail.com
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}












